import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { organisationNameSelector } from 'src/app/global/store/global.selectors';
import { State } from 'src/app/store';
import { UserService } from '../../service/user.abstract.service';
import { ProfileResponse } from '../../user.model';

@Component({
    selector: 'app-user-delete-dialog',
    templateUrl: './user-delete.component.html',
    styleUrls: ['./user-delete.component.scss'],
})
export class UserDeleteDialogComponent implements OnInit {
    public profile: ProfileResponse;
    public organisation: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { id: string },
        public dialogRef: MatDialogRef<UserDeleteDialogComponent>,
        public userService: UserService,
        private store: Store<State>,
    ) {}

    ngOnInit(): void {
        this.store
            .select(organisationNameSelector)
            .pipe(
                filter((organisation): organisation is string => Boolean(organisation)),
                take(1),
            )
            .subscribe((organisation) => (this.organisation = organisation));
        this.userService.getProfileById(this.data.id).subscribe((profile) => (this.profile = profile));
    }

    deleteUser(): void {
        this.dialogRef.close(true);
    }

    closeModal(): void {
        this.dialogRef.close(false);
    }
}
